import { ArgumentError } from '../utils/errors';
import { BaseAPIModel, fetcher } from '@weezevent/weezjs-core';

export default class TransfersModel extends BaseAPIModel {
    static getState({ organizationId }) {
        if (!organizationId) {
            throw new ArgumentError(`[Model][EventSettings][getAll] organizationId is mandatory`);
        }

        return fetcher.get(`/ticket/organizations/${organizationId}/accountancy/transfers/stats`);
    }

    static getInfo({ organizationId }, url) {
        if (!organizationId) {
            throw new ArgumentError(`[Model][EventSettings][getAll] organizationId is mandatory`);
        }

        return fetcher.get(`/ticket/organizations/${organizationId}/accountancy/transfers`, { query: url });
    }
}
